import type React from "react";
import { Heading, type HeadingProps, styled, Text } from "tamagui";
import tamaguiConfig from "../../tamagui.config";
import { Input, type InputProps } from "./InputNew";
import { Skeleton } from "./Skeleton";

const titleStyle = {
  color: "$color",
  fontFamily: "$heading",
  fontWeight: "$true",
  lineHeight: "$true",
  fontSize: "$true",
} as const;

export const Title = ({
  children,
  muted,
  ...props
}: HeadingProps & { muted?: boolean }) => {
  return (
    <Text {...titleStyle} color={muted ? "$muted" : "$color"} {...props}>
      {children}
    </Text>
  );
};

export const Title2 = styled(Heading, {
  ...titleStyle,
  variants: {
    size: {
      "1": {
        fontSize: 24,
      },
      "2": {
        fontSize: 16,
      },
    },
  },
});

export const TitleTextarea: React.FC<InputProps> = (props) => {
  return <Input backgroundColor="transparent" {...titleStyle} {...props} />;
};

export const TitleSkeleton: React.FC = () => {
  return (
    <Skeleton
      width={300}
      height={tamaguiConfig.fonts.heading.lineHeight.true}
    />
  );
};
